import { render, staticRenderFns } from "./AbaEditarAtracoesArtisticas.vue?vue&type=template&id=16dac4af&scoped=true"
import script from "./AbaEditarAtracoesArtisticas.vue?vue&type=script&lang=ts"
export * from "./AbaEditarAtracoesArtisticas.vue?vue&type=script&lang=ts"
import style0 from "./AbaEditarAtracoesArtisticas.vue?vue&type=style&index=0&id=16dac4af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dac4af",
  null
  
)

export default component.exports